export default __webpack_public_path__ + "static/media/APE (1).965c62ca.png";